import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { UserDTO } from '../models/UserDTO.model';
import { PlanDTO } from '../models/PlanDTO.model';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { SimpleRequestString } from '../shared/models/SimpleRequestString';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { CarrierDTO } from '../models/CarrierDTO.model';
import { ResponseBase } from '../models/ResponseBase';
import { PlanTypeDTO } from '../models/Plans/PlanTypeDTO';
import { ThresholdSettingsDto } from '../models/settings/ThresholdSettingsDto';
import { CarrierApiSettingsDto } from '../models/settings/CarrierApiSettingsDto';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {


  constructor(private httpService: HttpService) { }



  getThresholdSettings() {
    return this.httpService.get<ThresholdSettingsDto[]>(ApiRoutesEnum.GetThresholdSettings).pipe(
      tap((data) => {
      })
    );
  }

  updateThresholdSetting( request: ThresholdSettingsDto) {
    return this.httpService.put<ThresholdSettingsDto>(ApiRoutesEnum.UpdateThresholdSetting, request).pipe(
      tap((data) => {
      })
    );
  }

  getCarrierApiSettings() {
    return this.httpService.get<CarrierApiSettingsDto[]>(ApiRoutesEnum.GetCarrierApiSettings).pipe(
      tap((data) => {
      })
    );
  }

  updateCarrierApiSetting(request: CarrierApiSettingsDto) {
    return this.httpService.put<CarrierApiSettingsDto>(ApiRoutesEnum.UpdateCarrierApiSetting, request).pipe(
      tap((data) => {
      })
    );
  }



}

